// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"d0086259","1317":"cd382519","4727":"e4b93a9b","9507":"d0086259"}[chunkId] + ".chunk.css";
};